import React from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const navigate = useNavigate();

  const scrollToProducts = () => {
    const products = document.getElementById("products");

    if (products) {
      products.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="hero">
     <div className="hero-topbar">
  <div className="hero-topbar-item">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
    <span>Express 15–20 Minute Pickup</span>
  </div>

  <div className="hero-topbar-item">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
    <span>500+ Products</span>
  </div>
</div>

      <div className="hero-content">
        <div className="hero-text">

          <h1 className="hero-title">
            Your Stationery,
            <br />
            <span className="hero-highlight">Ready in a Flash</span>
          </h1>

          <p className="hero-subtitle">
            Premium pens, notebooks, art supplies &amp; more. Order now and
            pick up in just 15 minutes.
          </p>

          <div className="hero-cta">
            <button className="btn-primary" onClick={scrollToProducts}>
              Shop Now
            </button>

            <button
              className="btn-secondary"
              onClick={() => navigate("/orders")}
            >
              Track Order
            </button>
          </div>
        </div>

        <div className="hero-art" aria-hidden="true">
          <div className="hero-art-glow" />

          <div className="hero-books">
            <div className="hero-book hero-book-bottom" />
            <div className="hero-book hero-book-middle" />
            <div className="hero-notebook">
              <span className="notebook-ring ring-1" />
              <span className="notebook-ring ring-2" />
              <span className="notebook-ring ring-3" />
              <span className="notebook-ring ring-4" />
              <span className="notebook-ring ring-5" />
            </div>
          </div>

          <div className="hero-pencil-holder">
            <span className="hero-pencil pencil-orange" />
            <span className="hero-pencil pencil-navy" />
            <span className="hero-pencil pencil-black" />
            <span className="hero-pencil pencil-wood" />
            <div className="hero-cup" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;